import App from './App.vue'
import AuthService from './auth/AuthService'
import CKEditor from '@ckeditor/ckeditor5-vue'
import InstantSearch from 'vue-instantsearch'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import './plugins/vuetify'
import { createProvider } from './vue-apollo'
import VueAnalytics from 'vue-analytics'

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-139900117-2',
    router
  })
}

Vue.use(CKEditor)
Vue.use(InstantSearch)
Vue.use(VeeValidate)
Vue.prototype.$auth0 = new AuthService()
Vue.config.productionTip = false

new Vue({
  apolloProvider: createProvider(),
  router,
  store,

  $_veeValidate: {
    validator: 'new'
  },

  render: h => h(App)
}).$mount('#app')
